import { useEffect, useState } from "react";

/**
 * Subscribes to a media query. Used to keep scroll-linked motion off phones,
 * where parallax costs frames and adds nothing on a short viewport.
 */
export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const list = window.matchMedia(query);
    const onChange = (event) => setMatches(event.matches);
    setMatches(list.matches);
    list.addEventListener("change", onChange);
    return () => list.removeEventListener("change", onChange);
  }, [query]);

  return matches;
};

/** True from the two-column breakpoint upward. */
export const useIsDesktop = () => useMediaQuery("(min-width: 993px)");

export default useMediaQuery;
